import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title = "Trivana Hospitality - Hotel & Restaurant Management Software",
  description = "Smart hotel & restaurant automation – streamline rooms, tables, inventory & billing with Trivana's all-in-one management platform.",
  keywords = "hotel management software, restaurant management system, POS system, inventory management, table booking, room booking, hospitality software, hotel automation, restaurant automation, billing software",
  image = "https://trivanahospitality.com/images/trivanalogo.jpg",
  url = "https://trivanahospitality.com",
  type = "website",
  author = "Trivana Hospitality",
  twitterHandle = "@trivanahospitality"
}) => {
  const fullTitle = title.includes('Trivana') ? title : `${title} | Trivana Hospitality`;
  const fullUrl = url.startsWith('http') ? url : `https://trivanahospitality.com${url}`;
  const fullImage = image.startsWith('http') ? image : `https://trivanahospitality.com${image}`;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content={author} />
      <link rel="canonical" href={fullUrl} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={fullImage} />
      <meta property="og:site_name" content="Trivana Hospitality" />
      <meta property="og:locale" content="en_US" />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={fullUrl} />
      <meta property="twitter:title" content={fullTitle} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={fullImage} />
      <meta property="twitter:creator" content={twitterHandle} />

      {/* Additional Meta Tags */}
      <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
      <meta name="googlebot" content="index, follow" />
      <meta name="bingbot" content="index, follow" />
      
      {/* Mobile Meta Tags */}
      <meta name="mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-status-bar-style" content="black-translucent" />
      <meta name="apple-mobile-web-app-title" content="Trivana" />

      {/* Schema.org JSON-LD */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Organization",
          "name": "Trivana Hospitality",
          "url": "https://trivanahospitality.com",
          "logo": "https://trivanahospitality.com/images/trivanalogo.jpg",
          "description": description,
          "contactPoint": {
            "@type": "ContactPoint",
            "contactType": "Customer Service",
            "email": "trivanahospitality@gmail.com"
          },
          "sameAs": [
            "https://www.linkedin.com/company/trivana-hospitality",
            "https://www.instagram.com/trivanahospitality",
            "https://www.facebook.com/trivanahospitality"
          ]
        })}
      </script>
    </Helmet>
  );
};

export default SEO;
